const getImagePath = (name: string): string => {
  if (!name) {
    return '';
  }
  return (process.env.REACT_APP_API_UCF || '')
    .toString()
    .replace('Forms', `Files/${name}`);
};

export default getImagePath;
